export default "__VITE_ASSET__IELn$x0n__"